import { GenericService } from "./GenericService";
import { Config } from "./Config";
import { BodySecurityResponseForceEncripted } from "../utils/encripted";

export class TemplatesServices {
    static instance;

    constructor() {
        this.baseUrl = "Template";
    }

    static getInstance() {
        if (!TemplatesServices.instance) {
            TemplatesServices.instance = new TemplatesServices();
        }
        return TemplatesServices.instance;
    }

    async handleResponse(response) {
        console.log("document handleResponse: ", response)
        let respObject = response.data.data;

        if (respObject.ResponseCode !== 0) {
            const responseObject = {
                message: `${respObject.Messages ?? respObject.Message} ${respObject.TansactionId ? respObject.TansactionId : ""
                    } ${respObject.statusText ? respObject.statusText : ""}`,
            };
            console.log('handleResponse respObject ', respObject, responseObject)
            const error = respObject || responseObject || respObject?.Body;
            return Promise.reject(error);
        }
        return respObject?.Body === undefined || respObject?.Body === null ? {
            Body:
                respObject?.Response !== undefined && respObject?.Response !== null ?
                    respObject.Response
                    : respObject
        } : respObject;
    }

    async handleResponseForceEncripted(response) {
        var respObject = BodySecurityResponseForceEncripted(response.data.data);
        if (!respObject.IsOK) {
            var responseObject = {
                message: `${respObject.Messages} ${respObject.TansactionId ? respObject.TansactionId : ""
                    } ${respObject.statusText ? respObject.statusText : ""}`,
            };
            const error = respObject.Body || responseObject;
            return Promise.reject(error);
        }
        return respObject;
    }

    async UploadTemplateData(data) {
        try {
            const response = await GenericService.post({
                endpoint: `${this.baseUrl}/UploadTemplate2`,
                data: data,
                //  Config.setParametersForceEncripted(data, false),
                config: Config.configAuth(),
            });
            const dataUsers = await this.handleResponseForceEncripted(response);
            return dataUsers;
        } catch (error) {
            console.log('ERRORSERVER', error)
        }
    }

    async GetTemplates(data) {
        console.log('GetTemplates', data)
        const response = await GenericService.get({
            endpoint: `${this.baseUrl}/GetTemplates?categoria_Id=${data}`,
            config: Config.configAuth(),
        });
        console.log('GetTemplates response: ', response)
        const dataRes = await this.handleResponse(response);
        return dataRes;
    };


    async GetTemplatesActive(data) {
        console.log('GetTemplatesActive', data)
        const response = await GenericService.get({
            endpoint: `${this.baseUrl}/GetTemplatesActive?categoria_Id=${data}`,
            config: Config.configAuth(),
        });
        console.log('GetTemplatesActive response: ', response)
        const dataRes = await this.handleResponse(response);
        return dataRes;
    };

    async GetCategoriesTemplate(data) {
        console.log('GetCategoriesTemplate rquest: *** --- ', data)
        const response = await GenericService.get({
            endpoint: `${this.baseUrl}/GetCategoriesTemplate?references=${data}`,
            config: Config.configAuth(),
        });
        console.log('GetCategoriesTemplate response:*** -- ', response)
        const dataRes = await this.handleResponse(response);
        return dataRes;
    };

    async UpdateDocumentTemplateFieldsCustom(data) {
        try {
            const response = await GenericService.post({
                endpoint: `${this.baseUrl}/UpdateDocumentTemplateFieldsCustom`,
                data: data,
                config: Config.configAuth(),
            });
            return response.data.data;
        } catch (error) {
            console.log('ERROR SERVER', error)
            return error
        }
    }
    async ConvertDocToImagesProps(data) {
        console.log('responsedata', data)

        try {
            const response = await GenericService.post({
                endpoint: `${this.baseUrl}/ConvertDocToImagesProps?documentTemplate_Id=${data}`,
                data: data,
                config: Config.configAuth(),
            });
            console.log('responsedata', response)
            return response.data.data;
        } catch (error) {
            console.log('ERROR SERVER', error)
            return error
        }
    }

    async AddTraceSignDocumentTemplate(data) {
        try {
            const response = await GenericService.post({
                endpoint: `${this.baseUrl}/AddTraceSignDocumentTemplate`,
                data: data,
                config: Config.configAuth(),
            });
            return response.data.data;
        } catch (error) {
            console.log('ERROR SERVER', error)
            return error
        }
    }

    async DeleteTraceSignDocument(data) {
        try {
            const response = await GenericService.post({
                endpoint: `${this.baseUrl}/DeleteTraceSignDocument`,
                data: data,
                config: Config.configAuth(),
            });
            return response.data.data;
        } catch (error) {
            console.log('ERROR SERVER', error)
            return error
        }
    }

    async GetContentTemplate(data) {
        try {
            console.log('GetContentTemplate', data)
            const response = await GenericService.get({
                endpoint: `${this.baseUrl}/GetContentTemplate?template_Id=${data.template_Id}`,
                config: Config.configAuth(),
            });
            console.log('GetContentTemplate response: ', response)
            const dataRes = await this.handleResponse(response);
            return dataRes;
        } catch (error) {
            console.log('ERROR SERVER', error)
            return error
        }
    };

    async GetRolesByFile(data) {
        try {
            const response = await GenericService.get({
                endpoint: `FileCustom/GetRolesByFile?file_id=${data}`,
                data: data,
                config: Config.configAuth(),
            });
            const dataRes = await this.handleResponse(response);
            return dataRes;
        } catch (error) {
            console.log('error', error)
        }
    }

    async GetFieldsCaptureParticipant(data) {
        try {
            const response = await GenericService.post({
                endpoint: `FileCustom/GetFieldsCaptureParticipant`,
                data: data,
                config: Config.configAuth(),
            });
            const dataRes = await this.handleResponse(response);
            return dataRes;
        } catch (error) {
            console.log('error', error)
        }
    }

    async GetDocumentTemplateFields(data) {
        try {
            const response = await GenericService.get({
                endpoint: `Template/GetDocumentTemplateFields?template_Id=${data}`,
                config: Config.configAuth(),
            });
            const dataRes = await this.handleResponse(response);
            return dataRes;
        } catch (error) {
            console.log('errorData', error)
        }
    }

}